import { createStyles } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    textInfo: {
        display: "flex",
        flexDirection: "column",
        gap: ".25rem",
        fontSize: ".875rem",
        lineHeight: "normal",
        wordBreak: "break-word",
    },
    title: {
        color: theme.colors.gray[7],
    },
    value: {
        color: theme.colors.gray[9],
        fontWeight: 500,
        lineHeight: 1.5,
    },
}))
